import React from 'react';
import { Box, Paper, Typography, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export default function TargetAudienceCard({ card, image }) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: 'kit.background.middlepurple',
        width: { xs: 'calc(100vw - 52px)', sm: 424 },
        minHeight: { xs: 378, md: 424 },
        maxWidth: { xs: 287, sm: 311, md: 'none' },
        padding: { xs: '24px', md: '32px 32px 40px 32px' },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Typography
          component={'h3'}
          variant={isSm ? 'mobileH4' : 'desktopTitle'}
          sx={{ minHeight: { xs: 80, lg: 'auto' } }}
        >
          {(isSm && card.mobileTitle) || card.title}
        </Typography>
        <Typography
          component={'p'}
          variant="p2"
          sx={{ mt: 2, fontSize: { xs: 14, md: 18 } }}
        >
          {card.explaining}
        </Typography>
        <Box mt={'auto'} sx={{ marginBottom: card.margin }}>
          <GatsbyImage image={getImage(image)} alt={'target-audience-card'} />
        </Box>
      </Box>
    </Paper>
  );
}
